import { Text, View } from "@react-pdf/renderer";

const TechCardFooter = ({ date, day, dayNames }) => {
  return (
    <View
      fixed
      style={{
        position: "absolute",
        bottom: "10px",
        fontSize: "9px",
        display: "flex",
        flexDirection: "row",
        width: "90%",
        justifyContent: "space-between",
        marginLeft: "5%",
      }}
    >
      <Text
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
      ></Text>
      <Text style={{ color: "#f39200", fontSize: "11px" }}>
        Climate Prime v1.0.0.1
      </Text>
      <Text>{dayNames[day] + ", " + date} </Text>
    </View>
  );
};

export default TechCardFooter;
